// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"748":"44624963028a23ed","888":"683a7dc73678218f"}[chunkId] + ".css";
};